import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import GlobalStyles from './styles/GlobalStyles';
import theme from './styles/Theme';

// Components
import Header from './components/Header/Header';
import Hero from './components/Hero/Hero';
import Testimonials from './components/Testimonials/Testimonials';
import Benefits from './components/Benefits/Benefits';
import EthicalOffer from './components/EthicalOffer/EthicalOffer';
import Process from './components/Process/Process';
import CallToAction from './components/CallToAction/CallToAction';
import Footer from './components/Footer/Footer';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <Router>
        <Header />
        <main>
          <Hero />
          <Testimonials />
          <Benefits />
          <EthicalOffer />
          <Process />
          <CallToAction />
        </main>
        <Footer />
        <Routes>
          <Route path="/" element={<></>} />
          {/* Additional routes would be added here */}
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
